
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M16.82 9.986a.5.5 0 010 .699l-8.042 8.073a2 2 0 01-.679.45l-4.33 1.756a.5.5 0 01-.538-.11.5.5 0 01-.19-.619l1.716-4.331c.102-.255.254-.486.45-.679l8.05-8.053a.5.5 0 01.709 0l2.853 2.814zm3.74-5.888l-.658-.659c-.28-.28-.66-.439-1.057-.439h-.758a1.492 1.492 0 00-1.078.44l-1.806 1.825a.5.5 0 000 .699l2.804 2.844a.494.494 0 00.708 0l1.846-1.816c.286-.285.444-.674.439-1.078v-.758a1.49 1.49 0 00-.44-1.058z"}})])
          )
        }
      }
    